/** Existing Get Involved form used by Partner with LADOT (LLSU2-155). */
export const PARTNER_FORM_PATH = '/get-involved/feedback';
export const PARTNER_FORM_IWANTTO = 'become-a-leader';
export const PARTNER_FORM_HREF = `${PARTNER_FORM_PATH}/?iWantTo=${PARTNER_FORM_IWANTTO}`;

export const PARTNER_WITH_LADOT_TITLE = 'Partner with LADOT';
export const PARTNER_WITH_LADOT_INTRO =
  'LADOT is always looking for partners to support or community-first engagement efforts. Fill out the form below, if you want to get involved in our planning and outreach efforts for projects in your neighborhood.';

const PARTNER_IWANTTO_IDS = new Set(['become-a-leader', 'become-a-partner']);
const LEGACY_NAV_TITLES = new Set(['become a leader or partner organization']);

function normalizeText(value) {
  return String(value || '').trim().toLowerCase();
}

function parseSearch(search = '') {
  const query = String(search || '').startsWith('?') ? String(search).slice(1) : String(search || '');
  if (!query) return {};

  return query.split('&').reduce((obj, pair) => {
    const [rawKey, rawValue = ''] = pair.split('=');
    if (!rawKey) return obj;
    try {
      obj[decodeURIComponent(rawKey)] = decodeURIComponent(rawValue);
    } catch {
      obj[rawKey] = rawValue;
    }
    return obj;
  }, {});
}

export function isPartnerGetInvolvedSearch(search = '') {
  const iWantTo = normalizeText(parseSearch(search).iWantTo);
  return PARTNER_IWANTTO_IDS.has(iWantTo);
}

export function isPartnerWithLadotNavLink(link = {}) {
  const title = normalizeText(link.title || link.publicName || link.cmsName);
  const url = normalizeText(link.url);
  if (url.includes('iwantto=become-a-leader') || url.includes('iwantto=become-a-partner')) {
    return true;
  }
  return LEGACY_NAV_TITLES.has(title);
}

function partnerUrlAlreadyCorrect(url = '') {
  const [path = '', query = ''] = String(url).split('?');
  const normalizedPath = path.replace(/\/+$/, '') || '/';
  return normalizedPath === PARTNER_FORM_PATH && isPartnerGetInvolvedSearch(query);
}

export function rewritePartnerWithLadotNavLink(link) {
  if (!link || !isPartnerWithLadotNavLink(link)) return link;

  const nextTitle = PARTNER_WITH_LADOT_TITLE;
  const nextUrl = partnerUrlAlreadyCorrect(link.url) ? link.url : PARTNER_FORM_HREF;
  const nextPublicName =
    link.publicName == null || link.publicName === '' || isPartnerWithLadotNavLink({title: link.publicName})
      ? nextTitle
      : link.publicName;

  if (link.title === nextTitle && link.url === nextUrl && (link.publicName == null || link.publicName === nextPublicName)) {
    return link;
  }

  return {
    ...link,
    title: nextTitle,
    url: nextUrl,
    ...(link.publicName == null ? {} : {publicName: nextPublicName}),
  };
}

export function withPartnerWithLadotNavLinks(mListNav) {
  if (!mListNav) return mListNav;
  const links = Array.isArray(mListNav.navigationLinks) ? mListNav.navigationLinks : [];
  let changed = false;
  const navigationLinks = links.map((link) => {
    const rewritten = rewritePartnerWithLadotNavLink(link);
    if (rewritten !== link) changed = true;
    return rewritten;
  });
  if (!changed) return mListNav;
  return {...mListNav, navigationLinks};
}

export function rewritePartnerWithLadotNavLinks(links = []) {
  return (Array.isArray(links) ? links : []).map(rewritePartnerWithLadotNavLink);
}
